// This is a mapping of ISO country codes to their display names.
// It is shared between the directoryBrowse and directoryZipSearch components.

export const ISO_COUNTRY_NAMES = {
  AU: 'Australia',
  CA: 'Canada',
  DE: 'Germany',
  FR: 'France',
  GB: 'United Kingdom',
  MX: 'Mexico',
  US: 'United States',
}
